import {Trans, useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {Button, TitleH3, TitleH4} from "components/generic";
import {HOST_TENANTS_ROUTE, MONTHS, STUDENT_MATCHES_ROUTE,} from "utils/constants";
import {TModeInvitation} from "../MessagesList";
import {theme} from "styles/theme";
import {MessageWrapperDlg} from "../MessagesList/styles";
import {ButtonGroup, TextInfoContainer} from "./styles";
import {useEffect, useRef, useState} from "react";
import {MessageActions, MessageTypeNames} from "../../../interfaces/interfacesChat";

// export const NoChatsInfoSection = () => {
//   const history = useHistory();
//   const { t } = useTranslation("chats");
//   return (
//     <>
//       <TitleH3>{t("noChats.text")}</TitleH3>
//     </>
//   );
// };

export const NoChatsInfoSection: React.FC<{
  isHost: string;
}> = ({ isHost }) => {
  const { t } = useTranslation("chats");
  return (
    <>
      <TitleH3>{t(`noChats.${isHost === "true" ? "host" : "student"}.text`)}</TitleH3>
    </>
  );
};

export const SendMessageInfoSection: React.FC<{
  name: string;
  isHost: boolean;
}> = ({ name, isHost }) => {
  const { t } = useTranslation("chats");
  return (
    <TextInfoContainer alignCenter>
      <>
        <Trans
          t={t}
          i18nKey={`${isHost ? "host" : "student"}.emptyChat.title`}
          values={{ name }}
          parent="p"
        />
        <p>
          <span>{t(`${isHost ? "host" : "student"}.emptyChat.text`)}</span>
        </p>
      </>
    </TextInfoContainer>
  );
};

export const InvitationMessage: React.FC<{
  isHost: boolean;
  name: string;
  interval: string;
  latestRead: string[]
  setLatestRead: any
  handleInvitation: (mode: TModeInvitation) => void;
} & any> = (props) => {
  const { isHost, name, interval, handleInvitation } = props;
  const [start, end] = interval.split(",");
  const { t } = useTranslation("chats");
  const { t: t_cal, i18n } = useTranslation();
  const [startY, startM, startD] = start.slice(0, 10).split("-");
  const [endY, endM, endD] = end ?  end.slice(0, 10).split("-") : ['', '', ''];

  const lineDate = `${startD} ${t_cal(
    `calendar.months.${MONTHS[Number(startM) - 1]}`
  )
    .toLocaleLowerCase()
    .slice(0, 3)}
${startY !== endY ? startY : ""} - ${endD} ${t_cal(
      `calendar.months.${MONTHS[Number(endM) - 1]}`
    )
      .toLocaleLowerCase()
      .slice(0, 3)}
${endY}`;


  const useIsInViewport = () => {
    const elementRef = useRef<any>(null)
    const [isInViewPort, setIsInViewPort] = useState(false)

    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        const isInViewPort = !!entries[0]?.isIntersecting

        setIsInViewPort(isInViewPort)
      })
      if(elementRef.current) {
        //@ts-ignore
        observer.observe(elementRef.current)
      }

      return () => observer.disconnect()
    }, [])

    return {elementRef, isInViewPort}
  }

  const {elementRef: viewportRef, isInViewPort} = useIsInViewport()

  useEffect(() => {
    if(isInViewPort && !props.isOwn && !props.is_read && !props.latestRead!.includes(props.created_at)) {
      //@ts-ignore
      props.setLatestRead(prev => [...prev, props.created_at])
      props.handleMsg('read',
          MessageActions.MESSAGE_READ,
          props.created_at)
    }
  }, [isInViewPort, props.created_at, props.handleMsg, props.isOwn, props.setLatestRead, viewportRef, props.latestRead])

  return (
    <MessageWrapperDlg ref={viewportRef}>
      {isHost ? (
        <>
          <TitleH3 style={{ textAlign: "center" }}>
            <Trans t={t} i18nKey="host.textInvited" values={{ name }} />{" "}
            {lineDate}
          </TitleH3>
          <TitleH4 style={{ color: theme.colors.textDimmed }}>
            {t("host.waitingConfirmation")}
          </TitleH4>
          <ButtonGroup>
            <Button normal onClick={() => handleInvitation("cancelInvitation")}>
              {t("host.cancelInvitation")}
            </Button>
          </ButtonGroup>
        </>
      ) : (
        <>
          <TitleH3>{`${name} ${t("student.whoInvates")}`}{" "}{lineDate}</TitleH3>
          <TitleH4>{t("student.askAccept")}</TitleH4>
          <ButtonGroup>
            <Button normal
                    onClick={() => handleInvitation("decline")}
            >
              {t("student.buttons.decline")}
            </Button>
            <Button main
                    onClick={() => handleInvitation("acceptOffer")}
            >
              {t("student.buttons.accept")}
            </Button>
          </ButtonGroup>
        </>
      )}
    </MessageWrapperDlg>
  );
};

export const DeletedChat: React.FC<any> = (props) => {


  const useIsInViewport = () => {
    const elementRef = useRef<any>(null)
    const [isInViewPort, setIsInViewPort] = useState(false)

    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        const isInViewPort = !!entries[0]?.isIntersecting

        setIsInViewPort(isInViewPort)
      })
      if(elementRef.current) {
        //@ts-ignore
        observer.observe(elementRef.current)
      }

      return () => observer.disconnect()
    }, [])

    return {elementRef, isInViewPort}
  }

  const {elementRef: viewportRef, isInViewPort} = useIsInViewport()

  useEffect(() => {
    if(isInViewPort && !props.isOwn && !props.is_read && !props.latestRead!.includes(props.created_at)) {
      //@ts-ignore
      props.setLatestRead(prev => [...prev, props.created_at])
      props.handleMsg('read',
          MessageActions.MESSAGE_READ,
          props.created_at)
    }
  }, [isInViewPort, props.created_at, props.handleMsg, props.isOwn, props.setLatestRead, viewportRef, props.latestRead])

  return (
      <MessageWrapperDlg style={{ width: "98%" }}>
        <TitleH3
            ref={viewportRef}
            style={{
              textAlign: "center",
              whiteSpace: "pre-wrap",
              lineHeight: "0.8",
            }}
        >
          {props.text}
        </TitleH3>
      </MessageWrapperDlg>
  )
}

export const InvitationMessageResault: React.FC<any> = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("chats");

  const useIsInViewport = () => {
    const elementRef = useRef<any>(null)
    const [isInViewPort, setIsInViewPort] = useState(false)

    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        const isInViewPort = !!entries[0]?.isIntersecting

        setIsInViewPort(isInViewPort)
      })
      if(elementRef.current) {
        //@ts-ignore
        observer.observe(elementRef.current)
      }

      return () => observer.disconnect()
    }, [])

    return {elementRef, isInViewPort}
  }

  const {elementRef: viewportRef, isInViewPort} = useIsInViewport()

  useEffect(() => {
    if(isInViewPort && !props.isOwn && !props.is_read && !props.latestRead!.includes(props.created_at)) {
      //@ts-ignore
      props.setLatestRead(prev => [...prev, props.created_at])
      props.handleMsg('read',
          MessageActions.MESSAGE_READ,
          props.created_at)
    }
  }, [isInViewPort, props.created_at, props.handleMsg, props.isOwn, props.setLatestRead, viewportRef, props.latestRead])

  return (
    <MessageWrapperDlg style={{ width: "98%" }} ref={viewportRef}>
      {props.isHost ? (
        <>
          <TitleH3
            style={{
              textAlign: "center",
              whiteSpace: "pre-wrap",
              lineHeight: "0.8",
            }}
          >
            {t(`host.${props.success ? "studentAccepted" : "studentDeclined"}`, {
              joinArrays: "\n\n",
            })}
          </TitleH3>
          <ButtonGroup>
            <Button normal onClick={() => navigate(`/${i18n.language}${HOST_TENANTS_ROUTE.slice(5)}`)}>
              {t("host.buttons.goToTenants")}
            </Button>
          </ButtonGroup>
        </>
      ) : (
        <>
          <TitleH3
            style={{
              textAlign: "center",
              whiteSpace: "pre-wrap",
              lineHeight: "0.8",
            }}
          >
            {t(`student.${props.success ? "acceptedInvitation" : "hostCanceled"}`, {
              joinArrays: "\n\n",
            })}
          </TitleH3>
          <ButtonGroup>
            <Button normal onClick={() => navigate(STUDENT_MATCHES_ROUTE)}>
              {t("student.buttons.goToMatches")}
            </Button>
          </ButtonGroup>
        </>
      )}
    </MessageWrapperDlg>
  );
};

export const RemovedInterestOrHouse = (props: any) => {
  const { t, i18n } = useTranslation("chats");

  const {isHost} = props;

  const useIsInViewport = () => {
    const elementRef = useRef<any>(null)
    const [isInViewPort, setIsInViewPort] = useState(false)

    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        const isInViewPort = !!entries[0]?.isIntersecting

        setIsInViewPort(isInViewPort)
      })
      if(elementRef.current) {
        //@ts-ignore
        observer.observe(elementRef.current)
      }

      return () => observer.disconnect()
    }, [])

    return {elementRef, isInViewPort}
  }

  const {elementRef: viewportRef, isInViewPort} = useIsInViewport()

  useEffect(() => {
    if(isInViewPort && !props.isOwn && !props.is_read && !props.latestRead!.includes(props.created_at)) {
      //@ts-ignore
      props.setLatestRead(prev => [...prev, props.created_at])
      props.handleMsg('read',
          MessageActions.MESSAGE_READ,
          props.created_at)
    }
  }, [isInViewPort, props.created_at, props.handleMsg, props.isOwn, props.setLatestRead, viewportRef, props.latestRead])

  const messageToShow = (props.body.type === 'place_not_available' || props.body.text === 'House demoted to draft') ? 'RemovedHouse' : 'RemovedInterest'
  const role = isHost ? 'host' : 'student'

  return (
      <MessageWrapperDlg style={{ width: "98%" }}>
        <TitleH3
            ref={viewportRef}
            style={{
              textAlign: "center",
              whiteSpace: "pre-wrap",
              lineHeight: "0.8",
            }}
        >
          {
            t(`${role}${messageToShow}`)
          }
        </TitleH3>
      </MessageWrapperDlg>
  )
}
